import { View, ViewType } from "@common/types/views/views";

export enum HistoryDocumentDetailsColumn {
    TIME = "time",
    DOCUMENT_NAME = "documentName",
    ENTITY = "entity",
    ACCOUNT = "account",
    PREVIOUS = "previous",
    MODIFIED = "modified",
}

export type HistoryDocumentDownloadColumn =
    | HistoryDocumentDetailsColumn.TIME
    | HistoryDocumentDetailsColumn.DOCUMENT_NAME
    | HistoryDocumentDetailsColumn.ENTITY;

export interface HistoryDocumentDetailsView extends View {
    type: ViewType.HISTORY_UPDATED_TRANSACTION;
    columns: Array<{
        id: HistoryDocumentDetailsColumn;
        options?: Record<string, unknown>;
    }>;
}
